<template>
  <div class="flex items-center gap-x-2.5">
    <DpaIdMinifeed
      v-if="isPermittedForNewsfeed()"
      stage="prod"
      :token="accessToken"
      arrow-distance-right-mobile="80px"
      overlay-top="18px"
      overlay-top-mobile="48px" />
    <DpaIdAppswitcher arrow-distance-right="18px" overlay-top="18px" />
    <DpaIdUsericon
      :firstname="user?.given_name"
      :img-url="user?.picture"
      :initials="user?.initials"
      :lastname="user?.family_name"
      :overlay-right="'-12px'"
      :overlay-top="'16px'"
      @logout="onLogoutClick" />
  </div>
</template>

<script lang="ts" setup>
import {
  DpaIdAppswitcher,
  DpaIdMinifeed,
  DpaIdUsericon,
} from "@dpa-it/dpa-id-partner-components-vue";
import { ref, watch } from "vue";

import useAuth from "@/composition/shared/useAuth.ts";
import useAuthorization from "@/composition/shared/useAuthorization.ts";
import { useTracking } from "@/composition/shared/useTracking.ts";
import { getAccessToken } from "@/utils/apiClients.ts";

const { user, logout, isAuthenticated } = useAuth();

const { isPermittedForNewsfeed } = useAuthorization();
const { trackEvent } = useTracking();
const accessToken = ref<string | undefined>("");

const onLogoutClick = async (): Promise<void> => {
  trackEvent("header_click_button_idavatar", "ID-Avatar");
  await logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
};

watch(
  () => isAuthenticated.value,
  async (value) => {
    if (value) {
      accessToken.value = await getAccessToken();
    }
  },
  { immediate: true },
);
</script>
